import { useBreadcrumbItems } from 'features/Library/hooks/useBreadcrumbItems';

import { DroppableBreadcrumbsMapper } from './DroppableBreadcrumbsMapper';

export const DroppableBreadcrumbs = () => {
  const breadcrumbItems = useBreadcrumbItems();

  return <DroppableBreadcrumbsMapper breadcrumbItems={breadcrumbItems} />;
};
